export enum QueryParamKey {
  POSTAL_CODE = "postal_code",
  DISTANCE = "distance",
  PROVINCE = "province", // not used
  IN_STOCK = "in_stock",
  CATEGORY = "category",
  DEALER = "dealer",
  MODEL = "model",
  YEAR = "year",
  PRICE = "price",
  MILEAGE = "mileage",
  TRANSMISSION = "transmission",
  TRIMLINE = "trimline",
  COLOR_EXTERIOR = "color_exterior",
  COLOR_INTERIOR = "color_interior",
  VEHICLE_TYPES = "vehicle_types", // not used in favour of model

  // vehicles endpoint only
  VIN = "vin",
  SOURCE = "source",
  ID = "id",
  SORT_PRICE = "sort_price",
  SORT_ADDED = "sort_added",
  SORT_MILEAGE = "sort_mileage", // not used
  LIMIT = "limit"
};

export type SortOrder = "asc" | "desc";

export interface APISearchParameters {
  [QueryParamKey.POSTAL_CODE]: string;
  [QueryParamKey.DISTANCE]: string;
  [QueryParamKey.IN_STOCK]?: boolean;
  [QueryParamKey.CATEGORY]?: string;
  [QueryParamKey.DEALER]?: string;
  [QueryParamKey.MODEL]?: string;
  [QueryParamKey.YEAR]?: string;
  [QueryParamKey.PRICE]?: string;
  [QueryParamKey.MILEAGE]?: string;
  [QueryParamKey.TRANSMISSION]?: string;
  [QueryParamKey.TRIMLINE]?: string;
  [QueryParamKey.COLOR_EXTERIOR]?: string;
  [QueryParamKey.COLOR_INTERIOR]?: string;
  [QueryParamKey.LIMIT]?: number;
  [QueryParamKey.SORT_PRICE]?: SortOrder;
  [QueryParamKey.SORT_ADDED]?: SortOrder;
};

export interface ViewParameters {
  vehicle_types?: string;
  layout?: string;
}
